// extensions/CustomCell.ts
import { TableCell } from '@tiptap/extension-table-cell';

export const CustomCell = TableCell.extend({
  content: 'block+',

  addAttributes() {
    return {
      ...this.parent?.(),
      role: {
        default: null,
        parseHTML: el => el.getAttribute('data-role'),
        renderHTML: a => (a.role ? { 'data-role': a.role } : {}),
      },
      hidden: {
        default: false,
        parseHTML: el => el.getAttribute('data-hidden') === 'true',
        renderHTML: a => (a.hidden ? { 'data-hidden': 'true', style: 'display:none;' } : {}),
      },
    };
  }
});
